<template>
  <div class="pagination">
    <span
      v-if="pagination.pagesCount !== 1"
      class="pagination__button pagination__button--prev"
      :class="{
        'pagination__button--disabled': pagination.currentPage === 1
      }"
      @click="buttonClickHandler('prevPage')"
      role="button"
      tabindex="0"
      :aria-label="$t('global.pagination.prev.page')"
      @keydown="handleKeyDown"
    />
    <span class="pagination__label">{{ $t('productlist.page.label') }}</span>
    <select
      class="pagination__select"
      :aria-label="$t('category.page.count.input.label')"
      :class="{
        'pagination__select--disabled': pagination.pagesCount === 1
      }"
      :disabled="pagination.pagesCount === 1"
      v-model="selectPageValue"
    >
      <option
        v-for="page in pagination.pagesCount"
        :key="page"
        :value="page"
      >
        {{ page }}
      </option>
    </select>
    <span class="pagination__label">{{ $t('productlist.page.of.label') }}</span>
    <span class="pagination__pages-count">{{ pagination.pagesCount }}</span>
    <span
      v-if="pagination.pagesCount !== 1"
      class="pagination__button pagination__button--next"
      :class="{
        'pagination__button--disabled': pagination.currentPage === pagination.pagesCount
      }"
      @click="buttonClickHandler('nextPage')"
      role="button"
      tabindex="0"
      :aria-label="$t('global.pagination.next.page')"
      @keydown="handleKeyDown"
    />
  </div>
</template>

<script>
  import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js';

  export default {
    mixins: [
      plpStateComputedMixin,
    ],
    emits: ['pagechanged'],
    methods: {
      buttonClickHandler(direction) {
        this.$store.dispatch(`productsListPage/${direction}`);
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.$emit('pagechanged');
        }, 100)
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    },
    computed: {
      selectPageValue: {
        get() {
          return this.$store.state.productsListPage.pagination.currentPage;
        },
        set(value) {
          this.$store.dispatch('productsListPage/gotoPage', { value: value });
          setTimeout(() => {
            this.$emit('pagechanged');
          }, 100)
        }
      }
    }
  };

</script>
